import { css } from 'styled-components';
import { textStyle as textStyleFn, system } from 'styled-system';
import { get } from '../tools/utils';
export const BaseSharedStyles = css `
  ${({ fontWeight, fontStyle, theme: { colors } }) => `
    font-weight: ${fontWeight};
    font-style: ${fontStyle};
    color: ${colors['gray-900']};
  `}

  font-family: ${get.fonts('regular')};
  margin: 0;
  &:focus {
    outline: ${({ outlineOnFocus }) => outlineOnFocus ? 'inherit' : 'none'};
  }

  ${system({
    overflowWrap: true,
})};
`;
export const textBaseStyles = css `
  ${BaseSharedStyles};
  ${textStyleFn};

  ${({ theme, size }) => `
    line-height: ${theme.font.body[size].lineHeight};
    font-size: ${theme.font.body[size].size};
  `}
`;
export const headerBaseStyles = css `
  ${BaseSharedStyles};

  ${({ theme, size }) => `
    line-height: ${theme.font.heading[size].lineHeight};
    font-size: ${theme.font.heading[size].size};
  `}
`;
//# sourceMappingURL=styles.js.map